import { CreateHeaders, HeaderSizeEnum, currencyHeader, textHeader, IContactType, CurrencyEnum, toCurrency, Box, Tabs, Tab, SumRows, RadioFilterOpts } from '@frontend-workspace/react-shared-lib';
import styles from './monthly-churn-reports.module.scss';
import { addYears } from 'date-fns';
import { useContext, useState } from 'react';
import { ContactListContext } from '../customer-context/customer-context';
import { IMonthlyReportKeyNumbers } from '../_models/monthly-report-key-numbers';
import { ValueFormatterParams } from 'ag-grid-community';
import WebkuaTable from '../webkua-table/webkua-table';
import { UseDateRangeHook, useGetRequestNewHook, useMakeRequestHook } from '../requestUtils';
import { Col, Row } from 'reactstrap';
import WebkuaProductSelect from '../webkua-product-select/webkua-product-select';
import { IRelationProduct } from '../_models/relation-product';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface MonthlyChurnReportsProps {
  url: string;
}

export function MonthlyChurnReports(props: MonthlyChurnReportsProps) {
  const makeRequest = useMakeRequestHook();
  const { startDate, endDate, onDateChange } = UseDateRangeHook(addYears(new Date(), -1), new Date());
  const dateRange: DateRange<Date> = [new Date(startDate), new Date(endDate)];
  const [data, setData] = useState<IMonthlyReportKeyNumbers[]>([]);
  const { data: products }: { data: IRelationProduct[] } = useGetRequestNewHook(`relationProducts`, []);
  const [includeAcademic, setincludeAcademic] = useState<boolean>(false);
  const [includeFree, setIncludeFree] = useState<boolean>(false);
  const [includeNonAcademic, setIncludeNonAcademic] = useState<boolean>(true);
  const [includeComercial, setIncludeComercial] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [includeRestructuring, setIncludeRestructuring] = useState<boolean>(false);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [unpackSeatsPrQuantity, setUnpackSeatsPrQuantity] = useState<boolean>(true);
  const getData = () => {
    setIsLoading(true);
    makeRequest(props.url, "POST", {
      fromTime: startDate,
      untilTime: endDate,
      productIds: selectedProductIds,
      includeAcademic: includeAcademic,
      includeComercial: includeComercial,
      includeNonAcademic: includeNonAcademic,
      includeFree: includeFree,
      includeRestructuring: includeRestructuring,
      unpackSeatsPrQuantity: unpackSeatsPrQuantity
    }).then((response) => {
      setData(response);
      setIsLoading(false);
    })
  }

  return (
    <>
      <Row className="mb-3 mb-xl-0">
        <Col sm={6} md={12} lg={12} xl={6} xxl={4}>
          <div className='pe-3 mb-3 mb-md-0'>
            <WebkuaProductSelect
              relationProducts={products}
              selectedProductIds={selectedProductIds}
              setSelectedProductIds={setSelectedProductIds}
            />
          </div>
        </Col>
      </Row>
      <WebkuaTable
        expandComponent={ProductExpand}
        dateRange={dateRange}
        onSetDateRange={onDateChange}
        isLoading={isLoading}
        showNoDataAlert={!isLoading && data.length === 0}
        tableFilters={[
          {
            label: t("standard.nonAcademic"),
            checked: includeNonAcademic,
            onChange: setIncludeNonAcademic
          },
          // {
          //   label: "Ikke akademiske",
          //   checked: includeNonAcademic,
          //   onChange: setIncludeNonAcademic
          // },
          {
            label: t("standard.academic"),
            checked: includeAcademic,
            onChange: setincludeAcademic
          },
          // {
          //   label: "Gratislisenser",
          //   checked: includeFree,
          //   onChange: setIncludeFree
          // },
          {
            label: t("standard.unpackSeats"),
            checked: unpackSeatsPrQuantity,
            onChange: setUnpackSeatsPrQuantity
          },
          {
            label: t("standard.includeRestructuring"),
            checked: includeRestructuring,
            onChange: setIncludeRestructuring
          }
        ]}
        headers={CreateHeaders([
          textHeader("year", "År", HeaderSizeEnum.SMALL, {
            renderer: "agGroupCellRenderer",
            cellStyle: { fontSize: '0.875rem', fontWeight: '600' },
          }),
          textHeader("month", "Måned", HeaderSizeEnum.SMALL, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("companyChurn", "Firma churn (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("companyGrowthRate", "Firmavekst (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("seatChurn", "Sete churn (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("seatGrowthRate", "Setevekst (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("incomeChurn", "Inntekts churn (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("incomeGrowthRate", "Inntektsvekst (%)", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("seatDiff", "Sete diff.", HeaderSizeEnum.MEDIUM, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          currencyHeader("mrrDiff", "MRR Inntekts diff.", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          currencyHeader("mrr", "MRR Inntekt", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          currencyHeader("arr", "ARR Inntekt", HeaderSizeEnum.LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          }),
          textHeader("activeSeats", "Seter", HeaderSizeEnum.SMALL, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
        onRefresh={getData}
        data={data}

      />
    </>
  );
}
function ProductExpand(props: any) {
  const contactList = useContext<IContactType[]>(ContactListContext);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const report: IMonthlyReportKeyNumbers = props.data;

  const selectNewItems = () => setSelectedTab(0);
  const selectTerminatedItems = () => setSelectedTab(1);
  const selectChangedItems = () => setSelectedTab(2);
  const selectAllItems = () => setSelectedTab(3);
  const selectDiscountChangesItems = () => setSelectedTab(4);

  const yearlyValueRenderer = (params: ValueFormatterParams) => {
    return toCurrency(params.value * 12, params.data.currency || CurrencyEnum.NOK);
  };

  const companyNameRenderer = (params: ValueFormatterParams) => {
    const contact = contactList.find(c => c.number === params.value);
    return `${contact?.name} ${contact?.department}`;
  };

  const selectedItems = selectedTab === 0 ? report.newItems :
    selectedTab === 1 ? report.lostItems :
      selectedTab === 2 ? report.changedItems :
        selectedTab === 3 ? report.activeItems : report.discountChanges

  return <Box sx={{ padding: '20px' }}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
      <Tabs
        value={selectedTab}
        variant="scrollable"
        scrollButtons="auto">
        <Tab label={`Nye varer (${report.newItems.length})`} onClick={selectNewItems} />
        <Tab label={`Avsluttede varer (${report.lostItems.length})`} onClick={selectTerminatedItems} />
        <Tab label={`Endrede varer (${report.changedItems.length})`} onClick={selectChangedItems} />
        <Tab label={`Aktive varer (${report.activeItems.length})`} onClick={selectAllItems} />
        <Tab label={`Rabattendringer (${report.discountChanges.length})`} onClick={selectDiscountChangesItems} />
      </Tabs>
    </Box>
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("companyNumber", "Firmanr.", HeaderSizeEnum.MEDIUM),
        textHeader("companyName", "Firmanavn", HeaderSizeEnum.EXTRA_LARGE),
        textHeader("licenseNumber", "Lisensnr.", HeaderSizeEnum.MEDIUM),
        textHeader("licenseName", "Lisensnavn", HeaderSizeEnum.EXTRA_LARGE),
        textHeader("itemInfoId", "Vare", HeaderSizeEnum.LARGE),
        textHeader("quantity", "Seter", HeaderSizeEnum.SMALL, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header",
          summary: SumRows
        }),
        textHeader("discountPercent", "Rabatt %", HeaderSizeEnum.SMALL),
        currencyHeader("monthlyValue", "MRR", HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header",
          summary: SumRows
        }),
        currencyHeader("monthlyValue", "ARR", HeaderSizeEnum.LARGE, {
          renderer: yearlyValueRenderer,
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header",
          summary: SumRows
        })
      ])}
      data={selectedItems}
    />
  </Box>
    ;
}

export default MonthlyChurnReports;
